import { useState } from 'react';
import { api } from '@/services/api';
import type { Company } from '@/types';

export interface UseOnboardingCompanyReturn {
  createCompany: (data: { name: string; publicName?: string; description?: string }) => Promise<Company>;
  saving: boolean;
  error: string;
  setError: (error: string) => void;
}

export function useOnboardingCompany(): UseOnboardingCompanyReturn {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const createCompany = async (data: { name: string; publicName?: string; description?: string }): Promise<Company> => {
    setSaving(true);
    setError('');
    try {
      const company = await api.companies.create({
        name: data.name,
        publicName: data.publicName || data.name,
        description: data.description,
      });
      return company;
    } catch (err: any) {
      const msg = err?.message || 'Failed to create company. Please try again.';
      setError(msg);
      throw err;
    } finally {
      setSaving(false);
    }
  };

  return { createCompany, saving, error, setError };
}
